export const buildSessionIntegrationParamsData = (
  parameters: SessionIntegrationParameter[],
): PanelGridDataItem[] =>
  parameters.map((param) => ({
    ...param,
    key: param.name,
  }));
